import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import styles from '../../styles/LoadingSkeletons.module.css';

const skeletonSx = { bgcolor: 'rgba(255, 255, 255, 0.08)' };

const LeaderboardSkeletonRow = ({ isHeader = false }) => (
  <div
    className={`${styles.leaderboardSkeletonRow} ${
      isHeader ? styles.leaderboardSkeletonHeader : ''
    }`}
    aria-hidden="true"
  >
    <Skeleton variant="text" width={32} height={isHeader ? 18 : 24} sx={skeletonSx} />
    <Skeleton variant="text" width="90%" height={isHeader ? 18 : 24} sx={skeletonSx} />
    {Array.from({ length: 10 }, (_, index) => (
      <Skeleton
        key={`col-${index}`}
        variant="text"
        width="80%"
        height={isHeader ? 18 : 24}
        sx={skeletonSx}
      />
    ))}
  </div>
);

export const LeaderboardTableSkeleton = ({ rowCount = 10 }) => (
  <div
    className={styles.leaderboardSkeleton}
    role="status"
    aria-live="polite"
    aria-label="Loading leaderboard"
  >
    <LeaderboardSkeletonRow isHeader />
    {Array.from({ length: rowCount }, (_, index) => (
      <LeaderboardSkeletonRow key={`leaderboard-row-${index}`} />
    ))}
  </div>
);

LeaderboardTableSkeleton.propTypes = {
  rowCount: PropTypes.number,
};

export default LeaderboardTableSkeleton;
